__turbopack_context__.v({
  "buttonInner": "Button-module__R1Zl1G__buttonInner",
  "buttonSize__Large": "Button-module__R1Zl1G__buttonSize__Large",
  "buttonSize__Medium": "Button-module__R1Zl1G__buttonSize__Medium",
  "buttonSize__Small": "Button-module__R1Zl1G__buttonSize__Small",
  "buttonStyle__Primary": "Button-module__R1Zl1G__buttonStyle__Primary",
  "buttonStyle__Secondary": "Button-module__R1Zl1G__buttonStyle__Secondary",
  "buttonStyle__SecondaryTeal": "Button-module__R1Zl1G__buttonStyle__SecondaryTeal",
  "buttonStyle__SingleInputForm": "Button-module__R1Zl1G__buttonStyle__SingleInputForm",
  "buttonStyle__Tertiary": "Button-module__R1Zl1G__buttonStyle__Tertiary",
  "buttonStyle__TertiaryGrey2": "Button-module__R1Zl1G__buttonStyle__TertiaryGrey2",
  "daymadeButton": "Button-module__R1Zl1G__daymadeButton",
  "disabled": "Button-module__R1Zl1G__disabled",
  "flex1": "Button-module__R1Zl1G__flex1",
  "fullWidth": "Button-module__R1Zl1G__fullWidth",
  "loading": "Button-module__R1Zl1G__loading",
  "loadingAnimation": "Button-module__R1Zl1G__loadingAnimation",
});
